document.addEventListener('DOMContentLoaded', () => {
	const sortSelect = document.querySelector('select[name="sort"]')
	const urlParams = new URLSearchParams(window.location.search)
	const category = `&category=${urlParams.get('category')}`
	const baseURL = window.location.pathname

	sortSelect?.addEventListener('change', () => {
		let sortOptions = sortSelect.value.split('-')
		window.location = `${baseURL}?orderby=${sortOptions[0]}&order=${sortOptions[1]}${category}#posts`
	})
})
